
import { PrismaClient, Prisma, Collection, Role } from '@prisma/client'
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, BreadCrumb, CollectionCard, CreateCollectionModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    NavBar,
    BreadCrumb,
    CollectionCard,
    CreateCollectionModal
  }
})
export default class CollectionsView extends Vue {
  data () {
    return {
      activeTab: 0,
      popularCollections: [],
      myCollections: [],
      previewCollectionOpen: false,
      searchTerms: '',
      maxNumOfArtefatos: 10,
      numOfArtefatos: 10,
      numOfWords: 0,
      isLoading: false,
      popularSearch: '',
      myCollectionsSearch: ''
    }
  }

  mounted () {
    this.getPopularCollections()
    this.getMyCollections()
  }

  async createNewCollection () {
    this.previewCollectionOpen = true
  }

  async getPopularCollections () {
    this.isLoading = true
    try {
      this.popularCollections = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getPopularCollections/${this.popularSearch}`))
      this.isLoading = false
    } catch (e) {
      this.popularCollections = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get popular collections.',
        canCancel: false
      })
    }
  }

  async searchPopularCollections () {
    await this.getPopularCollections()
  }

  clearSearchPopularCollections () {
    this.popularSearch = ''
  }

  async getMyCollections () {
    this.isLoading = true
    try {
      this.myCollections = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getMyCollections/${this.myCollectionsSearch}`))
      this.isLoading = false
    } catch (e) {
      this.myCollections = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get my collections.',
        canCancel: false
      })
    }
  }

  async searchMyCollections () {
    await this.getMyCollections()
  }

  clearSearchMyCollections () {
    this.myCollectionsSearch = ''
  }

  removeCollectionCardFromMyCollections (obj) {
    var idx = this.myCollections.findIndex(e => e.id === obj.id)
    this.popularCollections.unshift(this.myCollections[idx])
    this.myCollections.splice(idx, 1)
  }

  addCollectionCardToMyCollections (obj) {
    var idx = this.popularCollections.findIndex(e => e.id === obj.id)
    this.myCollections.unshift(this.popularCollections[idx])
    this.popularCollections.splice(idx, 1)
  }

  async newCollectionCreated () {
    this.getMyCollections()
  }
}
